import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps } from 'react-router'
import AddTask from './Task/AddTask'
import EditTask from './Task/EditTask'
import GlobalTaskOverview from './Task/GlobalTaskOverview'
import TaskOverview from './Task/TaskOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'
import { BaseTaskOverviewProps } from './Task/BaseTaskOverview'

type Props = EntityPageProps & {
    fileId?: string
    overviewProps?: BaseTaskOverviewProps
}

export const taskBaseUrl = '/task'

export default function Tasks(props: Props): ReactElement {
    return (
        <EntityPage {...props} baseUrl={taskBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <>
                    <Route
                        exact
                        path={route}
                        render={(routeProps: RouteComponentProps) =>
                            props.fileId === undefined ? (
                                <GlobalTaskOverview baseUrl={baseUrl} />
                            ) : (
                                <TaskOverview
                                    {...routeProps}
                                    {...props}
                                    baseUrl={baseUrl}
                                    localStorageKeyPrefix={`HammockTaskOverview-${props.fileId}-`}
                                />
                            )
                        }
                    />
                    <Route path={`${route}/add`}>
                        <AddTask useFileContext={props.useFileContext} />
                    </Route>
                    <Route path={`${route}/:id/edit`}>
                        <EditTask useFileContext={props.useFileContext} />
                    </Route>
                </>
            )}
        </EntityPage>
    )
}
